import { dynamicGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import { segmentSchema } from "@redotech/redo-model/marketing/segments/segment-zod-schema";
import * as z from "zod";

export const createDynamicSegment = {
  name: "createDynamicSegment" as const,
  input: z.object({ name: z.string(), conditions: segmentSchema }),
  output: dynamicGroupSchema,
};
